function initNavbarPublic() {
  const navbarMenuButton = document.getElementById("navbar-public-menu-button");

  if (!navbarMenuButton) {
    return;
  }

  function isNavMenuOpen() {
    return document.body.classList.contains("navbar-public-menu-open");
  }

  function openNavMenu() {
    document.body.classList.add("navbar-public-menu-open");
    navbarMenuButton?.classList.add("is-active");
  }

  function closeNavMenu() {
    document.body.classList.remove("navbar-public-menu-open");
    navbarMenuButton?.classList.remove("is-active");
  }

  function toggleNavMenu() {
    if (isNavMenuOpen()) {
      closeNavMenu();
    } else {
      openNavMenu();
    }
  }

  if (navbarMenuButton) {
    navbarMenuButton.onclick = toggleNavMenu;
  }

  window.addEventListener("resize", closeNavMenu);
}

document.addEventListener("DOMContentLoaded", initNavbarPublic);
